<template>
  <div>
    <highcharts :constructorType="'mapChart'" class="hc" :options="chartOptions" ref="chart"></highcharts>
  </div>

</template>

<script>
import IndiaMap from './indiaGeo.geo.json'
export default {
  props: ['data'],
  data() {
    return {
      chartData: '',
      chartOptions: ''
    };
  },
  created() {
    this.chartData = this.data
    this.init();
  },
  methods: {
    init() {

      this.chartOptions = {
        chart: {
          map: IndiaMap,
          events: {
            click: function () {
              return false;
            },
            load: function () {
              this.update({
                mapNavigation: {
                  enabled: false
                }
              });
            }
          }
        },
        colors: ['rgba(19,64,117,0.05)'],
        title: {
          text: ''
        },
        exporting: {
          enabled: false,
        },
        subtitle: {
          text: ''
        },
        legend: {
          enabled: false,
          title: {
            text: ''
          }
        },
        tooltip: {
          // headerFormat: '',
          formatter() {
            if (this.point) {
              let mytooltip = ''
              mytooltip += '<span style="color:white;  font-weight:400; font-size:14px;  text-transform:capitalize;">';
              mytooltip += this.point.name + ": ";
              mytooltip += '</span>';
              mytooltip += '<span style="color:white; font-weight:400; font-size:14px;">';
              mytooltip += this.point.value == 105 ? 'NA' : this.point.value + '%'
              mytooltip += '</span>';
              return mytooltip;
            }
          },
          shared: true,
          useHTML: true,
          borderWidth: 0,
          shadow: {
            color: "rgba(0, 0, 0, 0.25)",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 10,
          backgroundColor: "#065559",
          padding: 12,
        },
        credits: {
          enabled: false,
        },
        mapNavigation: {
          enabled: true, 
          enableButtons: true,  
          buttonOptions: {
            verticalAlign: 'top'
          }
        },
        colorAxis: {
          min: 0
        },
        series: [{
          name: 'Country',
          dataLabels: {
            enabled: false,
            formatter: function () {
              if (this.point.value != 105 && this.point.value != null) {
                return this.point.name + '(' + this.point.value + '%)';
              }
            },
            style: {
              color: '#000'
            }
          },
          keys: ['hc-key', 'value', 'color'],
          nullColor: 'red',
          allAreas: true,
          data: this.chartData,
        }]
      }
    }
  }
};
</script>
